import { Card } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Container, { ContainerTypeMap } from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import React, { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface WrapperProps {
  children?: React.ReactNode;
  maxWidth?: ContainerTypeMap['props']['maxWidth'];
}

const useToggleLanguage = () => {
  const { i18n } = useTranslation();
  return () => {
    const currentIndex = i18n.languages.indexOf(i18n.language);
    const newIndex = (currentIndex + 1) % i18n.languages.length;
    i18n.changeLanguage(i18n.languages[newIndex]);
  };
};

export const CardWrapper = ({ children, maxWidth = 'xs' }: WrapperProps) => {
  const toggleLanguage = useToggleLanguage();
  const { t } = useTranslation();
  return (
    <Container component="main" maxWidth={maxWidth} disableGutters>
      <Card>
        <Stack component={CardContent} spacing={2}>
          <Grid
            container
            sx={{
              justifyContent: 'flex-end',
            }}
          >
            <Link
              href="#"
              align="right"
              onClick={(e: MouseEvent<HTMLAnchorElement>) => {
                e.preventDefault();
                toggleLanguage();
              }}
            >
              {t('toggleLanguage')}
            </Link>
          </Grid>
          <div>{children}</div>
        </Stack>
      </Card>
    </Container>
  );
};
